export const FETCH_TEAM_DETAILS = 'FETCH_TEAM_DETAILS';
export const FETCH_TEAM_DETAILS_SUCCESS = 'FETCH_TEAM_DETAILS_SUCCESS';
export const CLEAR_TEAM_DETAILS = 'CLEAR_TEAM_DETAILS';

export const SAVE_SPLIT_BREAKDOWN = 'SAVE_SPLIT_BREAKDOWN';
export const SAVE_SPLIT_BREAKDOWN_SUCCESS = 'SAVE_SPLIT_BREAKDOWN_SUCCESS';
export const SAVE_SPLIT_BREAKDOWN_FAILURE = 'SAVE_SPLIT_BREAKDOWN_FAILURE';
